import {get, set} from "lodash/object";
import {intersection} from "lodash/array";
import {crud} from "../transform";

export default function guard(fields, accessCheck: Array|Function, onFail: Function) {
    fields = Array.isArray(fields) ? fields : [fields];
    return ({typeDefs, resolvers}) => {
        fields.forEach(f => {
            const resolver = get(resolvers, f, get(crud().resolvers, f));
            if (resolver) {
                set(resolvers, f, (p, a, c, i)=>{
                    let hasAccess = false;
                    if (accessCheck instanceof Function) {
                        hasAccess = !!accessCheck(...arguments);
                    } else if (accessCheck instanceof Array && c.user) {
                        hasAccess = intersection(c.user.scopes, accessCheck).length > 0;
                    }
                    if (!hasAccess) {
                        if (onFail) return onFail(...arguments);
                        throw new Error("Access denied");
                    }
                    return resolver(p, a, c, i);
                })
            }
        })
        return {typeDefs, resolvers};
    }
}
